module.exports = __webpack_public_path__ + "static/media/apps.1e7d7256.png";